export const validateDependencies = (menuLink, menuUser, user) => {
  if (menuLink === undefined) 
    return 'Página não encontrada.';

  else if (menuUser === undefined || !menuUser?.length)
    return 'Menu do usuário não carregado.';

  else if (user === undefined)
    return 'Usuário não encontrado.';

  return null;
};

export const isRouteAuthenticated = (menuLink, isAdmin, menuUser, user) => {
  const isPageAdmin = isAdmin === true;
  const isAdminAccessDenied = isPageAdmin && user.accessInfo.admin === false;
  return menuUser.some(menu => menu.menuLink.toLowerCase() === menuLink.toLowerCase()) && !isAdminAccessDenied;
};